import { AxiosInstance } from 'axios';
import { imageScannerUrl } from 'keys';
import { FrameworkDefaultAxiosInstance } from 'framework/xhr/FrameworkDefaultAxiosInstance';

export const DefaultAxiosInstance = (): AxiosInstance => {
	return FrameworkDefaultAxiosInstance(imageScannerUrl);
};
